import type { QueryClient, QueryKey } from '@tanstack/react-query';

export function isConvexQueryKey(queryKey: QueryKey): boolean {
  return queryKey[0] === 'convexQuery';
}

export function createConvexQueryAuthLifecycle(
  queryClient: Pick<
    QueryClient,
    'cancelQueries' | 'removeQueries' | 'resetQueries'
  >
): (identity: string | null) => Promise<void> {
  let previousIdentity: string | null | undefined;
  let transitionQueue = Promise.resolve();

  return (identity) => {
    const transition = transitionQueue.then(async () => {
      if (previousIdentity === undefined) {
        previousIdentity = identity;
        return;
      }
      if (previousIdentity === identity) return;

      const convexQueries = {
        predicate: (query: { queryKey: QueryKey }) =>
          isConvexQueryKey(query.queryKey),
      };
      if (identity === null) {
        await queryClient.cancelQueries(convexQueries);
        queryClient.removeQueries(convexQueries);
      } else {
        await queryClient.resetQueries(convexQueries);
      }
      previousIdentity = identity;
    });
    transitionQueue = transition.catch(() => undefined);
    return transition;
  };
}
